module.exports = __webpack_public_path__ + "img/product-air-modal.9df43a78.png";